import { ArrowDownRightIcon, ArrowUpRightIcon } from "lucide-react";
import type { SentimentMover } from "@type/aiqm";
import { Card } from "@component/card";
import { cn } from "@util/tailwind";

interface SentimentMoversProps {
    // Top movers, pre-computed + pre-sorted by the BE (themes whose sentiment
    // changed most vs the previous period). This component only renders them.
    movers: SentimentMover[];
}

export default function SentimentMovers({ movers }: SentimentMoversProps) {
    if (movers.length === 0) return null;

    return (
        <Card className="p-4">
            <div className="mb-3">
                <h2 className="text-sm font-semibold text-gray-900">Biggest movers</h2>
                <p className="mt-0.5 text-xs text-gray-500">
                    Themes whose sentiment changed most vs the previous period.
                </p>
            </div>
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4">
                {movers.map((m) => {
                    const up = m.delta > 0;
                    return (
                        <div
                            key={m.id}
                            className="rounded-lg border border-gray-100 bg-gray-50 p-3"
                        >
                            <p
                                className="truncate text-xs font-medium text-gray-700"
                                title={m.label}
                            >
                                {m.label}
                            </p>
                            <div className="mt-1.5 flex items-center gap-1.5">
                                <span
                                    className={cn(
                                        "inline-flex items-center gap-0.5 text-sm font-semibold tabular-nums",
                                        up ? "text-emerald-600" : "text-rose-600"
                                    )}
                                >
                                    {up ? (
                                        <ArrowUpRightIcon className="h-3.5 w-3.5" />
                                    ) : (
                                        <ArrowDownRightIcon className="h-3.5 w-3.5" />
                                    )}
                                    {up ? "+" : ""}
                                    {m.delta}
                                </span>
                                <span className="text-xs text-gray-400">
                                    now {m.avg_sentiment > 0 ? "+" : ""}
                                    {m.avg_sentiment}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Card>
    );
}
